<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">活動</div>
            <div class="breadcrumb-item">積分支付抽獎日誌</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline">
              <FormItem>
                    <Select size="small" placeholder="獎品" v-model="form.type">
                        <Option value="1">積分</Option>
                        <Option value="2">集金幣</Option>
                    </Select>
                </FormItem>
               
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="積分支付抽獎-開始日期" v-model="form.start_time" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'>
                    </DatePicker>
                </FormItem>

                <FormItem>-</FormItem>
                
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false" placeholder="積分支付抽獎-結束日期" v-model="form.end_time" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'>
                    </DatePicker>
                </FormItem>
            </Form>
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">手機號碼</label>
                    <Input size="small" v-model="form.user_phone" @keyup.enter.native="handleSearch()" clearable></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch()">搜索</div>
                        <a target="_blank" class="pg-btn style2" @click="handleExport()"
                           style="margin-left: 15px;">導出excel</a>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table size="small"
           no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="avatar">
                    <div class="avatar-box">
                        <img :src="row.avatar" alt="">
                    </div>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style3" @click="handleIntegral(index)">積分操作</div>
                        <template v-if="remarks == 1">
                            <div class="pg-btn style2" @click="handleEdit(index)">編輯資料</div>
                            <div class="pg-btn style1" @click="handleDelete(index, 1)" v-if="row.status == 0">凍結賬戶</div>
                            <div class="pg-btn style1" @click="handleDelete(index, 0)" v-else-if="row.status == 1" style="background: #03a9f4;">啟用賬戶</div>
                        </template>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                isSubmiting: false,
                pageInput: '',
                form: {
                    start_time: '',
                    end_time: '',
                    user_phone: '',
                    type: '',
                },
                table: {
                    column: [
                      {
                        title: '抽獎日期',
                        key: 'lottery_time',
                        align: 'center',
                        sortable: true,
                        minWidth: 150
                      },
                      {
                        title: '手機號碼',
                        key: 'user_phone',
                        align: 'center',
                        sortable: true,
                        minWidth: 150
                      },
                      {
                        title: '流水號',
                        key: 'order',
                        align: 'center',
                        sortable: true,
                        minWidth: 150
                      },
                      {
                        title: '快遞單號',
                        key: 'odd_numbers',
                        align: 'center',
                        sortable: true,
                        minWidth: 150
                      },
                      {
                        title: '獎品',
                        key: 'type',
                        align: 'center',
                        sortable: true,
                        minWidth: 150
                      },
                    ],
                    data: []
                }
            };
        },
        mounted()
        {
            this.getList();
        },
        methods: {
            formatDate(datetime)
            {
                if (!datetime) return '';
            
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },
            getList()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.LotteryLogList,
                    method: 'get',
                    data: {
                        type: Number(form.type),
                        start_time: this.formatDate(form.start_time),
                        end_time: this.formatDate(form.end_time),
                        user_phone: Number(form.user_phone),
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                           if(resData[i].type == 1) {
                              resData[i].type = '';
                              resData[i].number = '立減' + resData[i].number;
                            }
                            else if(resData[i].type == 2) {
                              resData[i].type = '集金幣';
                              resData[i].number = '+' + resData[i].number;
                            }
                            else if(resData[i].type == 3) {
                              resData[i].type = '其他';
                            }
                            else {
                              resData[i].type = '- - -';
                            }

                             tempArr.push({
                                id: resData[i].id,
                                lottery_time: resData[i].lottery_time,
                                user_phone: resData[i].user_phone,
                                type: resData[i].number + resData[i].type,
                                order: resData[i].order,
                                odd_numbers: resData[i].odd_numbers == null ? '- - -' : resData[i].odd_numbers,
                             });
                        }
                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    } 
                    else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleExport() {
                let token = localStorage.getItem('jyb_token');
                let form = this.form;
                let params = {
                    'Authorization': token,
                    type: Number(form.type),
                    start_time: this.formatDate(form.start_time),
                    end_time: this.formatDate(form.end_time),
                    user_phone: Number(form.user_phone),
                    offset: (this.pageIndex - 1) * this.curPageSize,
                    limit: this.curPageSize,
                };
                let formatParams = this.$Utils.formateObjToParamStr(params);
                
                if(form.start_time == ''){
                    this.$Utils.showTipInfo("請選擇積分支付抽獎-開始日期");
                }
                else if(form.end_time == ''){
                    this.$Utils.showTipInfo("請選擇積分支付抽獎-結束日期");
                }
                else{
                    this.getList();
                    window.open(`${this.$Api.eventLogExcel}?${formatParams}`, '_blank');
                }
            },

            handleSearch()
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },

            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'LotteryLog.scss';
</style>